<template>
  <div class="text-content">
    <div v-if="loading" class="my-10 d-flex justify-center">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <div v-else v-html="content"></div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: String,
      default: "privacy",
    },
  },
  data() {
    return {
      content: null,
      loading: true,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    locale() {
      this.init();
    },
  },
  created() {
    // setTimeout(() => {
    this.init();
    // }, 1000);
  },
  methods: {
    async init() {
      const response = await this.axios.get("/md/" + this.file);
      this.content = response.data;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
// @import url("https://fonts.googleapis.com/css2?family=Open+Sans");

.text-content {
  font-family: "Open Sans", sans-serif;
  p,
  ul,
  ol {
    font-size: 1rem;
  }

  ul,
  ol {
    margin-top: 0.25rem;
  }

  h1,
  h2,
  h3,
  h4 {
    margin-top: 1rem;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  p {
    margin-top: 0.5rem;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
</style>
